(ns machtfit.holidays)

(def fixed-holidays
  {{:month 1 :day 1} "Neujahr"
   {:month 1 :day 6} "Heilige Drei Könige" #_"Feiertag in Baden-Württemberg, Bayern und Sachsen-Anhalt"
   {:month 3 :day 8} "Internationaler Frauentag" #_"Feiertag in Berlin"
   {:month 5 :day 1} "Tag der Arbeit"
   {:month 8 :day 15} "Mariä Himmelfahrt" #_"Feiertag in Bayern (tlw.) und im Saarland"
   {:month 10 :day 3} "Tag der Deutschen Einheit"
   {:month 10 :day 31} "Reformationstag" #_"Feiertag in Brandenburg, Mecklenburg-Vorpommern, Sachsen, Sachsen-Anhalt und Thüringen"
   {:month 11 :day 1} "Allerheiligen" #_"Feiertag in Baden-Württemberg, Bayern, Nordrhein-Westfalen, Rheinland-Pfalz und im Saarland"
   {:month 12 :day 25} "1. Weihnachtstag"
   {:month 12 :day 26} "2. Weihnachtstag"})

(def one-time-holidays
  {{:year 2020 :month 5 :day 8} "Tag der Befreiung" #_"Feiertag in Berlin"})

(def moveable-holidays
  {-2 "Karfreitag"
   0 "Ostersonntag"
   1 "Ostermontag"
   39 "Christi Himmelfahrt"
   49 "Pfingstsonntag"
   50 "Pfingstmontag"
   60 "Fronleichnam" #_"Feiertag in Baden-Württemberg, Bayern, Hessen, Nordrhein-Westfalen, Rheinland-Pfalz und im Saarland"})

(def easter-dates
  {2010 {:month 4 :day 4}
   2011 {:month 4 :day 24}
   2012 {:month 4 :day 8}
   2013 {:month 3 :day 31}
   2014 {:month 4 :day 20}
   2015 {:month 4 :day 5}
   2016 {:month 3 :day 27}
   2017 {:month 4 :day 16}
   2018 {:month 4 :day 1}
   2019 {:month 4 :day 21}
   2020 {:month 4 :day 12}
   2021 {:month 4 :day 4}
   2022 {:month 4 :day 17}
   2023 {:month 4 :day 9}
   2024 {:month 3 :day 31}
   2025 {:month 4 :day 20}
   2026 {:month 4 :day 5}
   2027 {:month 3 :day 28}
   2028 {:month 4 :day 16}
   2029 {:month 4 :day 1}
   2030 {:month 4 :day 21}})

;; Map school holidays for all states.
;; For each year and each state the holiday names are keys,
;; associated with a vector of range vectors; each range vector
;; can either contain 2 elements [day month] for a single day
;; range or 4 elements [from_day from_month to_day to_month] for
;; a date range (inclusive).
;;
;; The data can be grabbed from here:
;; http://www.schulferien.org/Schulferien_nach_Jahren/2016/schulferien_2016.html
;; and parsed out into the below structure like so:
;; dev/parse_school_holidays.py Schulferien\ 2016.html
(def school-holidays
  {2015
   {"Baden-Württemberg"
    {"Osterferien" [[30 3 10 4]]
     "Weihnachtsferien" [[23 12 9 1]]
     "Sommerferien" [[30 7 12 9]]
     "Schulfrei" [[31 10]]
     "Pfingstferien" [[26 5 6 6]]
     "Herbstferien" [[2 11 6 11]]}
    "Bayern"
    {"Osterferien" [[30 3 11 4]]
     "Weihnachtsferien" [[24 12 5 1]]
     "Sommerferien" [[1 8 14 9]]
     "Frühjahrsferien" [[16 2 20 2]]
     "Schulfrei" [[18 11]]
     "Pfingstferien" [[26 5 5 6]]
     "Herbstferien" [[2 11 7 11]]}
    "Berlin"
    {"Osterferien" [[30 3 11 4]]
     "Winterferien" [[2 2 7 2]]
     "Weihnachtsferien" [[23 12 2 1]]
     "Sommerferien" [[16 7 28 8]]
     "Schulfrei" [[15 5] [26 5]]
     "Herbstferien" [[19 10 31 10]]}
    "Brandenburg"
    {"Osterferien" [[1 4 11 4]]
     "Winterferien" [[2 2 7 2]]
     "Weihnachtsferien" [[23 12 2 1]]
     "Sommerferien" [[16 7 28 8]]
     "Schulfrei" [[15 5]]
     "Herbstferien" [[19 10 30 10]]}
    "Bremen"
    {"Osterferien" [[25 3 10 4]]
     "Winterferien" [[2 2 3 2]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Sommerferien" [[23 7 2 9]]
     "Schulfrei" [[15 5] [26 5]]
     "Herbstferien" [[19 10 31 10]]}
    "Hamburg"
    {"Osterferien" [[2 3 13 3]]
     "Weihnachtsferien" [[21 12 1 1]]
     "Sommerferien" [[16 7 26 8]]
     "Schulfrei" [[30 1]]
     "Pfingstferien" [[11 5 15 5]]
     "Herbstferien" [[19 10 30 10]]}
    "Hessen"
    {"Sommerferien" [[27 7 4 9]]
     "Osterferien" [[30 3 11 4]]
     "Weihnachtsferien" [[23 12 9 1]]
     "Herbstferien" [[19 10 31 10]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[30 3 8 4]]
     "Winterferien" [[2 2 14 2]]
     "Weihnachtsferien" [[21 12 2 1]]
     "Sommerferien" [[20 7 29 8]]
     "Pfingstferien" [[22 5 26 5]]
     "Herbstferien" [[24 10 30 10]]}
    "Niedersachsen"
    {"Osterferien" [[25 3 10 4]]
     "Winterferien" [[2 2 3 2]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Sommerferien" [[23 7 2 9]]
     "Schulfrei" [[15 5] [26 5]]
     "Herbstferien" [[19 10 31 10]]}
    "Nordrhein-Westfalen"
    {"Sommerferien" [[29 6 11 8]]
     "Osterferien" [[30 3 11 4]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Schulfrei" [[26 5]]
     "Herbstferien" [[5 10 17 10]]}
    "Rheinland-Pfalz"
    {"Sommerferien" [[27 7 4 9]]
     "Osterferien" [[26 3 10 4]]
     "Weihnachtsferien" [[23 12 8 1]]
     "Herbstferien" [[19 10 30 10]]}
    "Saarland"
    {"Sommerferien" [[27 7 5 9]]
     "Osterferien" [[30 3 11 4]]
     "Winterferien" [[16 2 21 2]]
     "Weihnachtsferien" [[21 12 2 1]]
     "Herbstferien" [[19 10 31 10]]}
    "Sachsen"
    {"Osterferien" [[2 4 11 4]]
     "Winterferien" [[9 2 21 2]]
     "Weihnachtsferien" [[21 12 2 1]]
     "Sommerferien" [[13 7 21 8]]
     "Schulfrei" [[15 5]]
     "Herbstferien" [[12 10 24 10]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[2 2 14 2]]
     "Weihnachtsferien" [[21 12 5 1]]
     "Sommerferien" [[13 7 26 8]]
     "Schulfrei" [[2 4]]
     "Pfingstferien" [[15 5 23 5]]
     "Herbstferien" [[17 10 24 10]]}
    "Schleswig-Holstein"
    {"Sommerferien" [[20 7 29 8]]
     "Osterferien" [[1 4 17 4]]
     "Weihnachtsferien" [[21 12 6 1]]
     "Schulfrei" [[15 5]]
     "Herbstferien" [[19 10 31 10]]}
    "Thüringen"
    {"Osterferien" [[30 3 11 4]]
     "Winterferien" [[2 2 7 2]]
     "Weihnachtsferien" [[23 12 2 1]]
     "Sommerferien" [[13 7 21 8]]
     "Schulfrei" [[15 5]]
     "Herbstferien" [[5 10 17 10]]}}

   2016
   {"Baden-Württemberg"
    {"Osterferien" [[29 3 2 4]]
     "Weihnachtsferien" [[23 12 7 1]]
     "Sommerferien" [[28 7 10 9]]
     "Schulfrei" [[24 3] [31 10]]
     "Pfingstferien" [[17 5 28 5]]
     "Herbstferien" [[2 11 4 11]]}
    "Bayern"
    {"Osterferien" [[21 3 1 4]]
     "Weihnachtsferien" [[24 12 5 1]]
     "Sommerferien" [[30 7 12 9]]
     "Frühjahrsferien" [[8 2 12 2]]
     "Schulfrei" [[16 11]]
     "Pfingstferien" [[17 5 28 5]]
     "Herbstferien" [[31 10 4 11]]}
    "Berlin"
    {"Osterferien" [[21 3 2 4]]
     "Winterferien" [[1 2 6 2]]
     "Weihnachtsferien" [[23 12 3 1]]
     "Sommerferien" [[21 7 2 9]]
     "Schulfrei" [[6 5] [17 5] [18 5]]
     "Herbstferien" [[17 10 28 10]]}
    "Brandenburg"
    {"Osterferien" [[23 3 2 4]]
     "Winterferien" [[1 2 6 2]]
     "Weihnachtsferien" [[23 12 3 1]]
     "Sommerferien" [[21 7 3 9]]
     "Schulfrei" [[6 5] [17 5]]
     "Herbstferien" [[17 10 28 10]]}
    "Bremen"
    {"Osterferien" [[18 3 2 4]]
     "Winterferien" [[28 1 29 1]]
     "Weihnachtsferien" [[21 12 6 1]]
     "Sommerferien" [[23 6 3 8]]
     "Schulfrei" [[6 5] [17 5]]
     "Herbstferien" [[4 10 15 10]]}
    "Hamburg"
    {"Osterferien" [[7 3 18 3]]
     "Weihnachtsferien" [[27 12 6 1]]
     "Sommerferien" [[21 7 31 8]]
     "Schulfrei" [[29 1] [6 5]]
     "Pfingstferien" [[17 5 20 5]]
     "Herbstferien" [[17 10 28 10]]}
    "Hessen"
    {"Sommerferien" [[18 7 26 8]]
     "Osterferien" [[29 3 9 4]]
     "Weihnachtsferien" [[22 12 7 1]]
     "Herbstferien" [[17 10 29 10]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[21 3 30 3]]
     "Winterferien" [[1 2 13 2]]
     "Weihnachtsferien" [[22 12 2 1]]
     "Sommerferien" [[25 7 3 9]]
     "Pfingstferien" [[14 5 17 5]]
     "Herbstferien" [[24 10 28 10]]}
    "Niedersachsen"
    {"Osterferien" [[18 3 2 4]]
     "Winterferien" [[28 1 29 1]]
     "Weihnachtsferien" [[21 12 6 1]]
     "Sommerferien" [[23 6 3 8]]
     "Schulfrei" [[6 5] [17 5]]
     "Herbstferien" [[4 10 15 10]]}
    "Nordrhein-Westfalen"
    {"Sommerferien" [[11 7 23 8]]
     "Osterferien" [[21 3 2 4]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Schulfrei" [[17 5]]
     "Herbstferien" [[10 10 21 10]]}
    "Rheinland-Pfalz"
    {"Sommerferien" [[18 7 26 8]]
     "Osterferien" [[18 3 1 4]]
     "Weihnachtsferien" [[22 12 6 1]]
     "Herbstferien" [[10 10 21 10]]}
    "Saarland"
    {"Sommerferien" [[18 7 27 8]]
     "Osterferien" [[29 3 9 4]]
     "Winterferien" [[8 2 13 2]]
     "Weihnachtsferien" [[19 12 31 12]]
     "Herbstferien" [[10 10 22 10]]}
    "Sachsen"
    {"Osterferien" [[25 3 2 4]]
     "Winterferien" [[8 2 20 2]]
     "Weihnachtsferien" [[23 12 2 1]]
     "Sommerferien" [[27 6 5 8]]
     "Schulfrei" [[6 5]]
     "Herbstferien" [[3 10 15 10]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[1 2 10 2]]
     "Weihnachtsferien" [[19 12 2 1]]
     "Sommerferien" [[27 6 10 8]]
     "Schulfrei" [[24 3]]
     "Pfingstferien" [[6 5 14 5]]
     "Herbstferien" [[4 10 15 10]]}
    "Schleswig-Holstein"
    {"Sommerferien" [[25 7 3 9]]
     "Osterferien" [[24 3 9 4]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Schulfrei" [[6 5]]
     "Herbstferien" [[17 10 29 10]]}
    "Thüringen"
    {"Osterferien" [[24 3 2 4]]
     "Winterferien" [[1 2 6 2]]
     "Weihnachtsferien" [[23 12 31 12]]
     "Sommerferien" [[27 6 10 8]]
     "Schulfrei" [[6 5]]
     "Herbstferien" [[10 10 22 10]]}}

   2017
   {"Baden-Württemberg"
    {"Sommerferien" [[27 7 9 9]]
     "Osterferien" [[10 4 21 4]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Pfingstferien" [[6 6 16 6]]
     "Herbstferien" [[30 10 3 11]]}
    "Bayern"
    {"Osterferien" [[10 4 22 4]]
     "Weihnachtsferien" [[23 12 5 1]]
     "Sommerferien" [[29 7 11 9]]
     "Frühjahrsferien" [[27 2 3 3]]
     "Schulfrei" [[22 11]]
     "Pfingstferien" [[6 6 16 6]]
     "Herbstferien" [[30 10 3 11]]}
    "Berlin"
    {"Osterferien" [[10 4 18 4]]
     "Winterferien" [[30 1 4 2]]
     "Weihnachtsferien" [[21 12 2 1]]
     "Sommerferien" [[20 7 1 9]]
     "Schulfrei" [[24 5] [26 5] [2 10]]
     "Pfingstferien" [[6 6 9 6]]
     "Herbstferien" [[23 10 4 11]]}
    "Brandenburg"
    {"Osterferien" [[10 4 22 4]]
     "Winterferien" [[30 1 4 2]]
     "Weihnachtsferien" [[21 12 2 1]]
     "Sommerferien" [[20 7 1 9]]
     "Schulfrei" [[26 5] [2 10]]
     "Herbstferien" [[23 10 4 11]]}
    "Bremen"
    {"Osterferien" [[10 4 22 4]]
     "Winterferien" [[30 1 31 1]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Sommerferien" [[22 6 2 8]]
     "Schulfrei" [[26 5] [6 6]]
     "Herbstferien" [[2 10 14 10]]}
    "Hamburg"
    {"Osterferien" [[6 3 17 3]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Sommerferien" [[20 7 30 8]]
     "Schulfrei" [[30 1] [2 10]]
     "Pfingstferien" [[22 5 26 5]]
     "Herbstferien" [[16 10 27 10]]}
    "Hessen"
    {"Sommerferien" [[3 7 11 8]]
     "Osterferien" [[3 4 15 4]]
     "Weihnachtsferien" [[24 12 13 1]]
     "Herbstferien" [[9 10 21 10]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[10 4 19 4]]
     "Winterferien" [[6 2 18 2]]
     "Weihnachtsferien" [[21 12 3 1]]
     "Sommerferien" [[24 7 2 9]]
     "Schulfrei" [[2 10]]
     "Pfingstferien" [[2 6 6 6]]
     "Herbstferien" [[23 10 30 10]]}
    "Niedersachsen"
    {"Osterferien" [[10 4 22 4]]
     "Winterferien" [[30 1 31 1]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Sommerferien" [[22 6 2 8]]
     "Schulfrei" [[26 5] [6 6] [30 10]]
     "Herbstferien" [[2 10 13 10]]}
    "Nordrhein-Westfalen"
    {"Sommerferien" [[17 7 29 8]]
     "Osterferien" [[10 4 22 4]]
     "Weihnachtsferien" [[27 12 6 1]]
     "Schulfrei" [[6 6]]
     "Herbstferien" [[23 10 4 11]]}
    "Rheinland-Pfalz"
    {"Sommerferien" [[3 7 11 8]]
     "Osterferien" [[10 4 21 4]]
     "Weihnachtsferien" [[22 12 9 1]]
     "Herbstferien" [[2 10 13 10]]}
    "Saarland"
    {"Sommerferien" [[3 7 14 8]]
     "Osterferien" [[10 4 22 4]]
     "Winterferien" [[27 2 4 3]]
     "Weihnachtsferien" [[21 12 5 1]]
     "Herbstferien" [[2 10 14 10]]}
    "Sachsen"
    {"Osterferien" [[13 4 22 4]]
     "Winterferien" [[13 2 24 2]]
     "Weihnachtsferien" [[23 12 2 1]]
     "Sommerferien" [[26 6 4 8]]
     "Schulfrei" [[26 5] [30 10]]
     "Herbstferien" [[2 10 14 10]]}
    "Sachsen-Anhalt"
    {"Osterferien" [[10 4 13 4]]
     "Winterferien" [[4 2 11 2]]
     "Weihnachtsferien" [[21 12 3 1]]
     "Sommerferien" [[26 6 9 8]]
     "Schulfrei" [[26 5] [30 10]]
     "Herbstferien" [[2 10 13 10]]}
    "Schleswig-Holstein"
    {"Sommerferien" [[24 7 2 9]]
     "Osterferien" [[7 4 21 4]]
     "Weihnachtsferien" [[21 12 6 1]]
     "Schulfrei" [[26 5]]
     "Herbstferien" [[16 10 27 10]]}
    "Thüringen"
    {"Osterferien" [[10 4 21 4]]
     "Winterferien" [[6 2 11 2]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Sommerferien" [[26 6 9 8]]
     "Schulfrei" [[26 5]]
     "Herbstferien" [[2 10 14 10]]}}
   2018
   {"Baden-Württemberg"
    {"Sommerferien" [[26 7 8 9]]
     "Osterferien" [[26 3 6 4]]
     "Weihnachtsferien" [[24 12 5 1]]
     "Pfingstferien" [[22 5 2 6]]
     "Herbstferien" [[29 10 2 11]]}
    "Bayern"
    {"Osterferien" [[26 3 7 4]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Sommerferien" [[30 7 10 9]]
     "Frühjahrsferien" [[12 2 16 2]]
     "Schulfrei" [[21 11]]
     "Pfingstferien" [[22 5 2 6]]
     "Herbstferien" [[29 10 2 11]]}
    "Berlin"
    {"Osterferien" [[26 3 6 4]]
     "Winterferien" [[5 2 10 2]]
     "Weihnachtsferien" [[22 12 5 1]]
     "Sommerferien" [[5 7 17 8]]
     "Schulfrei" [[30 4] [11 5] [22 5]]
     "Herbstferien" [[22 10 2 11]]}
    "Brandenburg"
    {"Osterferien" [[26 3 6 4]]
     "Winterferien" [[5 2 10 2]]
     "Weihnachtsferien" [[21 12 5 1]]
     "Sommerferien" [[5 7 18 8]]
     "Schulfrei" [[30 4] [11 5]]
     "Herbstferien" [[22 10 2 11]]}
    "Bremen"
    {"Osterferien" [[19 3 3 4]]
     "Winterferien" [[1 2 2 2]]
     "Weihnachtsferien" [[24 12 4 1]]
     "Sommerferien" [[28 6 8 8]]
     "Schulfrei" [[30 4] [11 5] [22 5]]
     "Herbstferien" [[1 10 13 10]]}
    "Hamburg"
    {"Osterferien" [[5 3 16 3]]
     "Weihnachtsferien" [[20 12 4 1]]
     "Sommerferien" [[5 7 15 8]]
     "Schulfrei" [[2 2] [30 4]]
     "Pfingstferien" [[7 5 11 5]]
     "Herbstferien" [[1 10 12 10]]}
    "Hessen"
    {"Sommerferien" [[25 6 3 8]]
     "Osterferien" [[26 3 7 4]]
     "Weihnachtsferien" [[24 12 12 1]]
     "Herbstferien" [[1 10 13 10]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[26 3 4 4]]
     "Winterferien" [[5 2 16 2]]
     "Weihnachtsferien" [[24 12 5 1]]
     "Sommerferien" [[9 7 18 8]]
     "Schulfrei" [[11 5]]
     "Pfingstferien" [[18 5 22 5]]
     "Herbstferien" [[8 10 13 10] [1 11 2 11]]}
    "Niedersachsen"
    {"Osterferien" [[19 3 3 4]]
     "Winterferien" [[1 2 2 2]]
     "Weihnachtsferien" [[24 12 4 1]]
     "Sommerferien" [[28 6 8 8]]
     "Schulfrei" [[30 4] [11 5] [22 5]]
     "Herbstferien" [[1 10 12 10]]}
    "Nordrhein-Westfalen"
    {"Sommerferien" [[16 7 28 8]]
     "Osterferien" [[26 3 7 4]]
     "Weihnachtsferien" [[21 12 4 1]]
     "Pfingstferien" [[22 5 25 5]]
     "Herbstferien" [[15 10 27 10]]}
    "Rheinland-Pfalz"
    {"Sommerferien" [[25 6 3 8]]
     "Osterferien" [[26 3 6 4]]
     "Weihnachtsferien" [[20 12 4 1]]
     "Herbstferien" [[1 10 12 10]]}
    "Saarland"
    {"Sommerferien" [[25 6 3 8]]
     "Osterferien" [[26 3 6 4]]
     "Winterferien" [[12 2 17 2]]
     "Weihnachtsferien" [[20 12 4 1]]
     "Herbstferien" [[1 10 12 10]]}
    "Sachsen"
    {"Osterferien" [[29 3 6 4]]
     "Winterferien" [[12 2 23 2]]
     "Weihnachtsferien" [[22 12 4 1]]
     "Sommerferien" [[2 7 10 8]]
     "Schulfrei" [[11 5]]
     "Pfingstferien" [[19 5 22 5]]
     "Herbstferien" [[8 10 20 10]]}
    "Sachsen-Anhalt"
    {"Osterferien" [[26 3 31 3]]
     "Winterferien" [[5 2 9 2]]
     "Weihnachtsferien" [[19 12 4 1]]
     "Sommerferien" [[28 6 8 8]]
     "Schulfrei" [[30 4]]
     "Pfingstferien" [[11 5 19 5]]
     "Herbstferien" [[1 10 12 10]]}
    "Schleswig-Holstein"
    {"Sommerferien" [[9 7 18 8]]
     "Osterferien" [[29 3 13 4]]
     "Weihnachtsferien" [[21 12 4 1]]
     "Schulfrei" [[11 5]]
     "Herbstferien" [[1 10 19 10]]}
    "Thüringen"
    {"Osterferien" [[26 3 7 4]]
     "Winterferien" [[5 2 9 2]]
     "Weihnachtsferien" [[21 12 4 1]]
     "Sommerferien" [[2 7 11 8]]
     "Schulfrei" [[11 5]]
     "Herbstferien" [[1 10 13 10]]}}

   2019
   {"Baden-Württemberg"
    {"Osterferien" [[15 4 27 4]]
     "Winterferien" [[4 3 8 3]]
     "Weihnachtsferien" [[23 12 4 1]]
     "Sommerferien" [[29 7 10 9]]
     "Pfingstferien" [[11 6 21 6]]
     "Herbstferien" [[28 10 30 10]]}
    "Bayern"
    {"Osterferien" [[15 4 27 4]]
     "Weihnachtsferien" [[23 12 4 1]]
     "Sommerferien" [[29 7 9 9]]
     "Frühjahrsferien" [[4 3 8 3]]
     "Schulfrei" [[20 11]]
     "Pfingstferien" [[11 6 21 6]]
     "Herbstferien" [[28 10 31 10]]}
    "Berlin"
    {"Osterferien" [[15 4 26 4]]
     "Winterferien" [[4 2 9 2]]
     "Weihnachtsferien" [[23 12 4 1]]
     "Sommerferien" [[20 6 2 8]]
     "Schulfrei" [[31 5] [11 6] [4 10]]
     "Herbstferien" [[7 10 19 10]]}
    "Brandenburg"
    {"Sommerferien" [[20 6 3 8]]
     "Osterferien" [[15 4 26 4]]
     "Winterferien" [[4 2 9 2]]
     "Weihnachtsferien" [[23 12 3 1]]
     "Herbstferien" [[4 10 18 10]]}
    "Bremen"
    {"Osterferien" [[6 4 23 4]]
     "Winterferien" [[31 1 1 2]]
     "Weihnachtsferien" [[21 12 6 1]]
     "Sommerferien" [[4 7 14 8]]
     "Schulfrei" [[31 5] [11 6]]
     "Herbstferien" [[4 10 18 10]]}
    "Hamburg"
    {"Osterferien" [[4 3 15 3]]
     "Weihnachtsferien" [[20 12 3 1]]
     "Sommerferien" [[27 6 7 8]]
     "Schulfrei" [[1 2] [31 5] [1 11]]
     "Pfingstferien" [[13 5 17 5]]
     "Herbstferien" [[4 10 18 10]]}
    "Hessen"
    {"Sommerferien" [[1 7 9 8]]
     "Osterferien" [[15 4 27 4]]
     "Weihnachtsferien" [[23 12 11 1]]
     "Herbstferien" [[30 9 12 10]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[15 4 24 4]]
     "Winterferien" [[4 2 15 2]]
     "Weihnachtsferien" [[23 12 4 1]]
     "Sommerferien" [[1 7 10 8]]
     "Schulfrei" [[31 5] [4 10] [1 11]]
     "Pfingstferien" [[7 6 11 6]]
     "Herbstferien" [[7 10 12 10]]}
    "Niedersachsen"
    {"Osterferien" [[8 4 23 4]]
     "Winterferien" [[31 1 1 2]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Sommerferien" [[4 7 14 8]]
     "Schulfrei" [[31 5] [11 6]]
     "Herbstferien" [[4 10 18 10]]}
    "Nordrhein-Westfalen"
    {"Sommerferien" [[15 7 27 8]]
     "Osterferien" [[15 4 27 4]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Schulfrei" [[11 6]]
     "Herbstferien" [[14 10 26 10]]}
    "Rheinland-Pfalz"
    {"Sommerferien" [[1 7 9 8]]
     "Osterferien" [[23 4 30 4]]
     "Winterferien" [[25 2 1 3]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Herbstferien" [[30 9 11 10]]}
    "Saarland"
    {"Sommerferien" [[1 7 9 8]]
     "Osterferien" [[17 4 26 4]]
     "Winterferien" [[25 2 5 3]]
     "Weihnachtsferien" [[23 12 3 1]]
     "Herbstferien" [[7 10 18 10]]}
    "Sachsen"
    {"Osterferien" [[19 4 26 4]]
     "Winterferien" [[18 2 2 3]]
     "Weihnachtsferien" [[21 12 3 1]]
     "Sommerferien" [[8 7 16 8]]
     "Schulfrei" [[31 5]]
     "Herbstferien" [[14 10 25 10]]}
    "Sachsen-Anhalt"
    {"Osterferien" [[18 4 30 4]]
     "Winterferien" [[11 2 15 2]]
     "Weihnachtsferien" [[23 12 4 1]]
     "Sommerferien" [[4 7 14 8]]
     "Schulfrei" [[1 11]]
     "Pfingstferien" [[31 5 1 6]]
     "Herbstferien" [[4 10 11 10]]}
    "Schleswig-Holstein"
    {"Sommerferien" [[1 7 10 8]]
     "Osterferien" [[4 4 18 4]]
     "Weihnachtsferien" [[23 12 6 1]]
     "Schulfrei" [[31 5]]
     "Herbstferien" [[4 10 18 10]]}
    "Thüringen"
    {"Osterferien" [[15 4 27 4]]
     "Winterferien" [[11 2 15 2]]
     "Weihnachtsferien" [[21 12 3 1]]
     "Sommerferien" [[8 7 17 8]]
     "Schulfrei" [[31 5]]
     "Herbstferien" [[7 10 19 10]]}}

   2020
   {"Baden-Württemberg"
    {"Osterferien" [[6 4 18 4]]
     "Pfingstferien" [[2 6 13 6]]
     "Sommerferien" [[30 7 12 9]]
     "Herbstferien" [[26 10 30 10]]
     "Schulfrei" [[31 10]]
     "Weihnachtsferien" [[23 12 9 1]]}
    "Bayern"
    {"Frühjahrsferien" [[24 2 28 2]]
     "Osterferien" [[6 4 18 4]]
     "Pfingstferien" [[2 6 13 6]]
     "Sommerferien" [[27 7 7 9]]
     "Herbstferien" [[31 10 6 11]]
     "Schulfrei" [[18 11]]
     "Weihnachtsferien" [[23 12 9 1]]}
    "Berlin"
    {"Winterferien" [[3 2 8 2]]
     "Osterferien" [[6 4 17 4]]
     "Schulfrei" [[22 5]]
     "Sommerferien" [[25 6 7 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[21 12 2 1]]}
    "Brandenburg"
    {"Winterferien" [[3 2 8 2]]
     "Osterferien" [[6 4 17 4]]
     "Sommerferien" [[25 6 8 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[21 12 2 1]]}
    "Bremen"
    {"Winterferien" [[3 2 4 2]]
     "Osterferien" [[28 3 14 4]]
     "Schulfrei" [[22 5] [2 6]]
     "Sommerferien" [[16 7 26 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Hamburg"
    {"Schulfrei" [[31 1]]
     "Osterferien" [[2 3 13 3]]
     "Pfingstferien" [[18 5 22 5]]
     "Sommerferien" [[25 6 5 8]]
     "Herbstferien" [[5 10 16 10]]
     "Weihnachtsferien" [[21 12 4 1]]}
    "Hessen"
    {"Osterferien" [[6 4 18 4]]
     "Sommerferien" [[6 7 14 8]]
     "Herbstferien" [[5 10 17 10]]
     "Weihnachtsferien" [[21 12 9 1]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[10 2 21 2]]
     "Osterferien" [[6 4 15 4]]
     "Schulfrei" [[22 5] [2 11] [3 11]]
     "Pfingstferien" [[29 5 2 6]]
     "Sommerferien" [[22 6 1 8]]
     "Herbstferien" [[5 10 10 10]]
     "Weihnachtsferien" [[21 12 2 1]]}
    "Niedersachsen"
    {"Winterferien" [[3 2 4 2]]
     "Osterferien" [[30 3 14 4]]
     "Schulfrei" [[22 5] [2 6]]
     "Sommerferien" [[16 7 26 8]]
     "Herbstferien" [[12 10 23 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[6 4 18 4]]
     "Schulfrei" [[2 6]]
     "Sommerferien" [[29 6 11 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Rheinland-Pfalz"
    {"Winterferien" [[17 2 21 2]]
     "Osterferien" [[9 4 17 4]]
     "Sommerferien" [[6 7 14 8]]
     "Herbstferien" [[12 10 23 10]]
     "Weihnachtsferien" [[21 12 31 12]]}
    "Saarland"
    {"Winterferien" [[17 2 25 2]]
     "Osterferien" [[14 4 24 4]]
     "Sommerferien" [[6 7 14 8]]
     "Herbstferien" [[12 10 23 10]]
     "Weihnachtsferien" [[21 12 31 12]]}
    "Sachsen"
    {"Winterferien" [[10 2 22 2]]
     "Osterferien" [[10 4 18 4]]
     "Schulfrei" [[22 5]]
     "Sommerferien" [[20 7 28 8]]
     "Herbstferien" [[19 10 31 10]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[10 2 14 2]]
     "Osterferien" [[6 4 11 4]]
     "Pfingstferien" [[18 5 30 5]]
     "Sommerferien" [[16 7 26 8]]
     "Herbstferien" [[19 10 24 10]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Schleswig-Holstein"
    {"Osterferien" [[30 3 17 4]]
     "Schulfrei" [[22 5]]
     "Sommerferien" [[29 6 8 8]]
     "Herbstferien" [[5 10 17 10]]
     "Weihnachtsferien" [[21 12 6 1]]}
    "Thüringen"
    {"Winterferien" [[10 2 14 2]]
     "Osterferien" [[6 4 18 4]]
     "Schulfrei" [[22 5]]
     "Sommerferien" [[20 7 29 8]]
     "Herbstferien" [[17 10 30 10]]
     "Weihnachtsferien" [[23 12 2 1]]}}

   2021
   {"Baden-Württemberg"
    {"Pfingstferien" [[25 5 5 6]]
     "Sommerferien" [[29 7 11 9]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Bayern"
    {"Osterferien" [[29 3 10 4]]
     "Pfingstferien" [[25 5 4 6]]
     "Sommerferien" [[30 7 13 9]]
     "Weihnachtsferien" [[24 12 8 1]]}
    "Berlin"
    {"Winterferien" [[1 2 6 2]]
     "Osterferien" [[29 3 10 4]]
     "Schulfrei" [[14 5]]
     "Sommerferien" [[24 6 6 8]]
     "Herbstferien" [[11 10 23 10]]}
    "Brandenburg"
    {"Winterferien" [[1 2 6 2]]
     "Osterferien" [[29 3 9 4]]
     "Sommerferien" [[24 6 7 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[20 12 31 12]]}
    "Bremen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[27 3 10 4]]
     "Sommerferien" [[22 7 1 9]]
     "Herbstferien" [[18 10 30 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Hamburg"
    {"Schulfrei" [[29 1]]
     "Osterferien" [[1 3 12 3]]
     "Pfingstferien" [[10 5 14 5]]
     "Sommerferien" [[24 6 4 8]]
     "Herbstferien" [[4 10 15 10]]
     "Weihnachtsferien" [[23 12 4 1]]}
    "Hessen"
    {"Osterferien" [[6 4 16 4]]
     "Sommerferien" [[19 7 27 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[29 3 7 4]]
     "Sommerferien" [[21 6 31 7]]
     "Weihnachtsferien" [[22 12 31 12]]}
    "Niedersachsen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[29 3 9 4]]
     "Sommerferien" [[22 7 1 9]]
     "Herbstferien" [[18 10 29 10]]
     "Weihnachtsferien" [[23 12 7 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[29 3 10 4]]
     "Schulfrei" [[25 5]]
     "Sommerferien" [[5 7 17 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[24 12 8 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[29 3 6 4]]
     "Pfingstferien" [[25 5 2 6]]
     "Sommerferien" [[19 7 27 8]]
     "Herbstferien" [[11 10 22 10]]
     "Weihnachtsferien" [[23 12 31 12]]}
    "Saarland"
    {"Winterferien" [[15 2 19 2]]
     "Osterferien" [[29 3 7 4]]
     "Pfingstferien" [[25 5 28 5]]
     "Sommerferien" [[19 7 27 8]]
     "Herbstferien" [[18 10 29 10]]
     "Weihnachtsferien" [[23 12 3 1]]}
    "Sachsen"
    {"Winterferien" [[31 1 6 2]]
     "Osterferien" [[27 3 10 4]]
     "Schulfrei" [[14 5]]
     "Sommerferien" [[26 7 3 9]]
     "Herbstferien" [[18 10 30 10]]
     "Weihnachtsferien" [[23 12 1 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[8 2 13 2]]
     "Osterferien" [[29 3 3 4]]
     "Pfingstferien" [[10 5 22 5]]
     "Sommerferien" [[22 7 1 9]]
     "Herbstferien" [[25 10 30 10]]
     "Weihnachtsferien" [[18 12 8 1]]}
    "Schleswig-Holstein"
    {"Osterferien" [[1 4 16 4]]
     "Pfingstferien" [[14 5 15 5]]
     "Sommerferien" [[21 6 31 7]]
     "Herbstferien" [[4 10 16 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Thüringen"
    {"Winterferien" [[25 1 30 1]]
     "Osterferien" [[29 3 10 4]]
     "Schulfrei" [[14 5]]
     "Sommerferien" [[26 7 4 9]]
     "Herbstferien" [[25 10 6 11]]
     "Weihnachtsferien" [[23 12 31 12]]}}

   2022
   {"Baden-Württemberg"
    {"Pfingstferien" [[7 6 18 6]]
     "Sommerferien" [[28 7 10 9]]
     "Weihnachtsferien" [[21 12 7 1]]}
    "Bayern"
    {"Frühjahrsferien" [[28 2 4 3]]
     "Osterferien" [[11 4 23 4]]
     "Pfingstferien" [[7 6 18 6]]
     "Sommerferien" [[1 8 12 9]]
     "Weihnachtsferien" [[24 12 7 1]]}
    "Berlin"
    {"Winterferien" [[29 1 5 2]]
     "Sommerferien" [[7 7 19 8]]
     "Herbstferien" [[24 10 5 11]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Brandenburg"
    {"Winterferien" [[31 1 5 2]]
     "Osterferien" [[11 4 23 4]]
     "Sommerferien" [[7 7 20 8]]
     "Herbstferien" [[24 10 5 11]]
     "Weihnachtsferien" [[22 12 3 1]]}
    "Bremen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[4 4 19 4]]
     "Sommerferien" [[14 7 24 8]]
     "Herbstferien" [[17 10 29 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Hamburg"
    {"Schulfrei" [[28 1]]
     "Osterferien" [[7 3 18 3]]
     "Pfingstferien" [[23 5 27 5]]
     "Sommerferien" [[7 7 17 8]]
     "Herbstferien" [[10 10 21 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Hessen"
    {"Osterferien" [[11 4 23 4]]
     "Sommerferien" [[25 7 2 9]]
     "Herbstferien" [[24 10 29 10]]
     "Weihnachtsferien" [[22 12 7 1]]}
    "Mecklenburg-Vorpommern"
    {"Osterferien" [[11 4 20 4]]
     "Sommerferien" [[4 7 13 8]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Niedersachsen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[4 4 19 4]]
     "Sommerferien" [[14 7 24 8]]
     "Herbstferien" [[17 10 28 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[11 4 23 4]]
     "Sommerferien" [[27 6 9 8]]
     "Herbstferien" [[4 10 15 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Rheinland-Pfalz"
    {"Winterferien" [[21 2 25 2]]
     "Osterferien" [[13 4 22 4]]
     "Sommerferien" [[25 7 2 9]]
     "Herbstferien" [[17 10 31 10]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Saarland"
    {"Winterferien" [[21 2 1 3]]
     "Osterferien" [[14 4 22 4]]
     "Pfingstferien" [[7 6 10 6]]
     "Sommerferien" [[25 7 2 9]]
     "Herbstferien" [[24 10 4 11]]
     "Weihnachtsferien" [[22 12 4 1]]}
    "Sachsen"
    {"Winterferien" [[12 2 26 2]]
     "Osterferien" [[15 4 23 4]]
     "Schulfrei" [[27 5]]
     "Sommerferien" [[18 7 26 8]]
     "Herbstferien" [[17 10 29 10]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[12 2 19 2]]
     "Osterferien" [[11 4 16 4]]
     "Pfingstferien" [[23 5 28 5]]
     "Sommerferien" [[14 7 24 8]]
     "Herbstferien" [[24 10 4 11]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Schleswig-Holstein"
    {"Osterferien" [[4 4 16 4]]
     "Pfingstferien" [[27 5 28 5]]
     "Sommerferien" [[4 7 13 8]]
     "Herbstferien" [[10 10 21 10]]
     "Weihnachtsferien" [[23 12 7 1]]}
    "Thüringen"
    {"Osterferien" [[11 4 23 4]]
     "Schulfrei" [[27 5]]
     "Sommerferien" [[18 7 27 8]]
     "Herbstferien" [[17 10 29 10]]
     "Weihnachtsferien" [[22 12 3 1]]}}

   2023
   {"Baden-Württemberg"
    {"Pfingstferien" [[30 5 9 6]]
     "Sommerferien" [[27 7 9 9]]
     "Herbstferien" [[30 10 3 11]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Bayern"
    {"Frühjahrsferien" [[20 2 24 2]]
     "Osterferien" [[3 4 15 4]]
     "Pfingstferien" [[30 5 9 6]]
     "Sommerferien" [[31 7 11 9]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Berlin"
    {"Winterferien" [[30 1 4 2]]
     "Osterferien" [[3 4 14 4]]
     "Sommerferien" [[13 7 25 8]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Brandenburg"
    {"Winterferien" [[30 1 3 2]]
     "Osterferien" [[3 4 14 4]]
     "Sommerferien" [[13 7 26 8]]
     "Herbstferien" [[23 10 4 11]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Bremen"
    {"Winterferien" [[30 1 31 1]]
     "Osterferien" [[27 3 11 4]]
     "Sommerferien" [[6 7 16 8]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Hamburg"
    {"Schulfrei" [[27 1]]
     "Osterferien" [[6 3 17 3]]
     "Pfingstferien" [[15 5 19 5]]
     "Sommerferien" [[13 7 23 8]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Hessen"
    {"Osterferien" [[3 4 22 4]]
     "Sommerferien" [[24 7 1 9]]
     "Herbstferien" [[23 10 28 10]]
     "Weihnachtsferien" [[27 12 13 1]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[6 2 18 2]]
     "Osterferien" [[3 4 12 4]]
     "Sommerferien" [[17 7 26 8]]
     "Weihnachtsferien" [[21 12 3 1]]}
    "Niedersachsen"
    {"Winterferien" [[30 1 31 1]]
     "Osterferien" [[27 3 11 4]]
     "Sommerferien" [[6 7 16 8]]
     "Weihnachtsferien" [[27 12 5 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[3 4 15 4]]
     "Schulfrei" [[30 5]]
     "Sommerferien" [[22 6 4 8]]
     "Herbstferien" [[2 10 14 10]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[3 4 6 4]]
     "Pfingstferien" [[30 5 7 6]]
     "Sommerferien" [[24 7 1 9]]
     "Herbstferien" [[16 10 27 10]]
     "Weihnachtsferien" [[27 12 5 1]]}
    "Saarland"
    {"Winterferien" [[20 2 24 2]]
     "Osterferien" [[3 4 12 4]]
     "Pfingstferien" [[30 5 2 6]]
     "Sommerferien" [[24 7 1 9]]
     "Herbstferien" [[23 10 3 11]]
     "Weihnachtsferien" [[21 12 2 1]]}
    "Sachsen"
    {"Winterferien" [[13 2 24 2]]
     "Osterferien" [[7 4 15 4]]
     "Schulfrei" [[19 5]]
     "Sommerferien" [[10 7 18 8]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[6 2 11 2]]
     "Osterferien" [[3 4 8 4]]
     "Pfingstferien" [[15 5 19 5]]
     "Sommerferien" [[6 7 16 8]]
     "Weihnachtsferien" [[21 12 3 1]]}
    "Schleswig-Holstein"
    {"Osterferien" [[6 4 22 4]]
     "Pfingstferien" [[19 5 20 5]]
     "Sommerferien" [[17 7 26 8]]
     "Herbstferien" [[16 10 27 10]]
     "Weihnachtsferien" [[27 12 6 1]]}
    "Thüringen"
    {"Winterferien" [[13 2 17 2]]
     "Osterferien" [[3 4 15 4]]
     "Schulfrei" [[19 5]]
     "Sommerferien" [[10 7 19 8]]
     "Herbstferien" [[2 10 14 10]]
     "Weihnachtsferien" [[22 12 5 1]]}}

   2024
   {"Baden-Württemberg"
    {"Osterferien" [[23 3 5 4]]
     "Pfingstferien" [[21 5 31 5]]
     "Sommerferien" [[25 7 7 9]]}
    "Bayern"
    {"Frühjahrsferien" [[12 2 16 2]]
     "Osterferien" [[25 3 6 4]]
     "Pfingstferien" [[21 5 1 6]]
     "Sommerferien" [[29 7 9 9]]
     "Weihnachtsferien" [[23 12 3 1]]}
    "Berlin"
    {"Winterferien" [[5 2 10 2]]
     "Osterferien" [[25 3 5 4]]
     "Schulfrei" [[10 5]]
     "Sommerferien" [[18 7 30 8]]
     "Weihnachtsferien" [[23 12 31 12]]}
    "Brandenburg"
    {"Winterferien" [[5 2 9 2]]
     "Osterferien" [[25 3 5 4]]
     "Sommerferien" [[18 7 31 8]]
     "Weihnachtsferien" [[23 12 31 12]]}
    "Bremen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[18 3 28 3]]
     "Sommerferien" [[24 6 2 8]]
     "Weihnachtsferien" [[23 12 4 1]]}
    "Hamburg"
    {"Schulfrei" [[2 2]]
     "Osterferien" [[18 3 28 3]]
     "Sommerferien" [[18 7 28 8]]}
    "Hessen"
    {"Osterferien" [[25 3 13 4]]
     "Sommerferien" [[15 7 23 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[5 2 16 2]]
     "Osterferien" [[25 3 3 4]]
     "Sommerferien" [[22 7 31 8]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Niedersachsen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[18 3 28 3]]
     "Sommerferien" [[24 6 3 8]]
     "Weihnachtsferien" [[23 12 4 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[25 3 6 4]]
     "Schulfrei" [[21 5]]
     "Sommerferien" [[8 7 20 8]]
     "Herbstferien" [[14 10 26 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[25 3 2 4]]
     "Pfingstferien" [[21 5 29 5]]
     "Sommerferien" [[15 7 23 8]]
     "Herbstferien" [[14 10 25 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Saarland"
    {"Winterferien" [[12 2 16 2]]
     "Osterferien" [[25 3 5 4]]
     "Pfingstferien" [[21 5 24 5]]
     "Sommerferien" [[15 7 23 8]]
     "Herbstferien" [[14 10 25 10]]
     "Weihnachtsferien" [[23 12 3 1]]}
    "Sachsen"
    {"Winterferien" [[12 2 23 2]]
     "Osterferien" [[28 3 5 4]]
     "Sommerferien" [[20 6 2 8]]
     "Herbstferien" [[7 10 19 10]]
     "Weihnachtsferien" [[23 12 3 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[5 2 10 2]]
     "Osterferien" [[25 3 30 3]]
     "Pfingstferien" [[21 5 24 5]]
     "Sommerferien" [[24 6 3 8]]
     "Weihnachtsferien" [[23 12 4 1]]}
    "Schleswig-Holstein"
    {"Osterferien" [[2 4 19 4]]
     "Pfingstferien" [[10 5 11 5]]
     "Sommerferien" [[22 7 31 8]]
     "Weihnachtsferien" [[19 12 7 1]]}
    "Thüringen"
    {"Winterferien" [[12 2 16 2]]
     "Osterferien" [[25 3 6 4]]
     "Schulfrei" [[10 5]]
     "Sommerferien" [[20 6 31 7]]
     "Herbstferien" [[30 9 12 10]]
     "Weihnachtsferien" [[23 12 3 1]]}}

   2025
   {"Baden-Württemberg"
    {"Sommerferien" [[31 7 13 9]]}
    "Bayern"
    {"Frühjahrsferien" [[3 3 7 3]]
     "Osterferien" [[14 4 25 4]]
     "Pfingstferien" [[10 6 20 6]]
     "Sommerferien" [[1 8 15 9]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Berlin"
    {"Winterferien" [[3 2 8 2]]
     "Schulfrei" [[10 6]]
     "Sommerferien" [[24 7 6 9]]
     "Herbstferien" [[20 10 1 11]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Brandenburg"
    {"Winterferien" [[3 2 8 2]]
     "Schulfrei" [[10 6]]
     "Sommerferien" [[24 7 6 9]]
     "Herbstferien" [[20 10 1 11]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Bremen"
    {"Winterferien" [[3 2 4 2]]
     "Osterferien" [[7 4 19 4]]
     "Sommerferien" [[3 7 13 8]]
     "Herbstferien" [[13 10 25 10]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Hamburg"
    {"Sommerferien" [[24 7 3 9]]}
    "Hessen"
    {"Sommerferien" [[7 7 15 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[3 2 14 2]]
     "Pfingstferien" [[6 6 10 6]]
     "Sommerferien" [[28 7 6 9]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Niedersachsen"
    {"Winterferien" [[3 2 4 2]]
     "Sommerferien" [[3 7 13 8]]
     "Herbstferien" [[13 10 25 10]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[14 4 26 4]]
     "Schulfrei" [[10 6]]
     "Sommerferien" [[14 7 26 8]]
     "Herbstferien" [[13 10 25 10]]
     "Weihnachtsferien" [[22 12 6 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[14 4 25 4]]
     "Sommerferien" [[7 7 15 8]]
     "Herbstferien" [[13 10 24 10]]
     "Weihnachtsferien" [[22 12 7 1]]}
    "Saarland"
    {"Winterferien" [[24 2 4 3]]
     "Osterferien" [[14 4 25 4]]
     "Sommerferien" [[7 7 14 8]]
     "Herbstferien" [[13 10 24 10]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Sachsen"
    {"Winterferien" [[17 2 1 3]]
     "Sommerferien" [[28 6 8 8]]
     "Herbstferien" [[6 10 18 10]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[27 1 31 1]]
     "Osterferien" [[7 4 19 4]]
     "Schulfrei" [[30 5]]
     "Sommerferien" [[28 6 8 8]]
     "Herbstferien" [[13 10 25 10]]
     "Weihnachtsferien" [[22 12 5 1]]}
    "Schleswig-Holstein"
    {"Schulfrei" [[3 2] [30 5]]
     "Sommerferien" [[28 7 6 9]]
     "Weihnachtsferien" [[19 12 6 1]]}
    "Thüringen"
    {"Winterferien" [[3 2 8 2]]
     "Osterferien" [[7 4 19 4]]
     "Schulfrei" [[30 5]]
     "Sommerferien" [[28 6 8 8]]
     "Herbstferien" [[6 10 18 10]]
     "Weihnachtsferien" [[22 12 3 1]]}}

   2026
   {"Baden-Württemberg"
    {"Sommerferien" [[30 7 12 9]]}
    "Bayern"
    {"Frühjahrsferien" [[16 2 20 2]]
     "Osterferien" [[30 3 10 4]]
     "Pfingstferien" [[26 5 5 6]]
     "Sommerferien" [[3 8 14 9]]
     "Weihnachtsferien" [[24 12 8 1]]}
    "Berlin"
    {"Winterferien" [[2 2 7 2]]
     "Schulfrei" [[26 5]]
     "Sommerferien" [[9 7 22 8]]
     "Herbstferien" [[19 10 31 10]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Brandenburg"
    {"Winterferien" [[2 2 7 2]]
     "Schulfrei" [[26 5]]
     "Sommerferien" [[9 7 22 8]]
     "Herbstferien" [[19 10 30 10]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Bremen"
    {"Winterferien" [[2 2 3 2]]
     "Osterferien" [[23 3 7 4]]
     "Sommerferien" [[2 7 12 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 9 1]]}
    "Hamburg"
    {"Sommerferien" [[9 7 19 8]]}
    "Hessen"
    {"Sommerferien" [[29 6 7 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[9 2 20 2]]
     "Osterferien" [[30 3 8 4]]
     "Sommerferien" [[13 7 22 8]]
     "Weihnachtsferien" [[19 12 2 1]]}
    "Niedersachsen"
    {"Winterferien" [[2 2 3 2]]
     "Osterferien" [[23 3 7 4]]
     "Sommerferien" [[2 7 12 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 9 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[30 3 11 4]]
     "Schulfrei" [[26 5]]
     "Sommerferien" [[20 7 1 9]]
     "Herbstferien" [[17 10 31 10]]
     "Weihnachtsferien" [[23 12 6 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[30 3 10 4]]
     "Sommerferien" [[29 6 7 8]]
     "Herbstferien" [[5 10 16 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Saarland"
    {"Winterferien" [[16 2 20 2]]
     "Osterferien" [[7 4 17 4]]
     "Sommerferien" [[29 6 7 8]]
     "Herbstferien" [[5 10 16 10]]
     "Weihnachtsferien" [[21 12 31 12]]}
    "Sachsen"
    {"Winterferien" [[9 2 21 2]]
     "Sommerferien" [[4 7 14 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 2 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[31 1 6 2]]
     "Osterferien" [[30 3 4 4]]
     "Pfingstferien" [[26 5 29 5]]
     "Sommerferien" [[4 7 14 8]]
     "Herbstferien" [[19 10 30 10]]
     "Weihnachtsferien" [[21 12 2 1]]}
    "Schleswig-Holstein"
    {"Winterferien" [[2 2 3 2]]
     "Osterferien" [[26 3 10 4]]
     "Schulfrei" [[15 5]]
     "Sommerferien" [[4 7 15 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[21 12 6 1]]}
    "Thüringen"
    {"Winterferien" [[16 2 21 2]]
     "Osterferien" [[7 4 17 4]]
     "Schulfrei" [[15 5]]
     "Sommerferien" [[4 7 14 8]]
     "Herbstferien" [[12 10 24 10]]
     "Weihnachtsferien" [[23 12 2 1]]}}

   2027
   {"Baden-Württemberg"
    {"Sommerferien" [[29 7 11 9]]}
    "Bayern"
    {"Frühjahrsferien" [[8 2 12 2]]
     "Osterferien" [[22 3 2 4]]
     "Pfingstferien" [[18 5 28 5]]
     "Sommerferien" [[2 8 13 9]]
     "Herbstferien" [[2 11 5 11]]
     "Weihnachtsferien" [[24 12 7 1]]}
    "Berlin"
    {"Winterferien" [[1 2 6 2]]
     "Pfingstferien" [[18 5 19 5]]
     "Sommerferien" [[1 7 14 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[22 12 31 12]]}
    "Brandenburg"
    {"Winterferien" [[1 2 6 2]]
     "Schulfrei" [[18 5]]
     "Sommerferien" [[1 7 14 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[23 12 31 12]]}
    "Bremen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[22 3 3 4]]
     "Sommerferien" [[8 7 18 8]]
     "Herbstferien" [[18 10 30 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Hamburg"
    {"Sommerferien" [[1 7 11 8]]}
    "Hessen"
    {"Sommerferien" [[28 6 6 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[8 2 19 2]]
     "Osterferien" [[22 3 31 3]]
     "Sommerferien" [[5 7 14 8]]
     "Weihnachtsferien" [[23 12 4 1]]}
    "Niedersachsen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[22 3 3 4]]
     "Sommerferien" [[8 7 18 8]]
     "Herbstferien" [[16 10 30 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[22 3 3 4]]
     "Schulfrei" [[18 5]]
     "Sommerferien" [[19 7 31 8]]
     "Herbstferien" [[23 10 6 11]]
     "Weihnachtsferien" [[24 12 8 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[22 3 2 4]]
     "Sommerferien" [[28 6 6 8]]
     "Herbstferien" [[4 10 15 10]]
     "Weihnachtsferien" [[23 12 7 1]]}
    "Saarland"
    {"Winterferien" [[8 2 12 2]]
     "Osterferien" [[30 3 9 4]]
     "Sommerferien" [[28 6 6 8]]
     "Herbstferien" [[4 10 15 10]]
     "Weihnachtsferien" [[20 12 31 12]]}
    "Sachsen"
    {"Winterferien" [[8 2 19 2]]
     "Osterferien" [[26 3 2 4]]
     "Sommerferien" [[10 7 20 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[23 12 1 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[1 2 6 2]]
     "Osterferien" [[22 3 27 3]]
     "Pfingstferien" [[15 5 22 5]]
     "Sommerferien" [[10 7 20 8]]
     "Herbstferien" [[18 10 23 10]]
     "Weihnachtsferien" [[20 12 31 12]]}
    "Schleswig-Holstein"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[30 3 10 4]]
     "Schulfrei" [[7 5]]
     "Sommerferien" [[3 7 14 8]]
     "Herbstferien" [[11 10 23 10]]
     "Weihnachtsferien" [[23 12 8 1]]}
    "Thüringen"
    {"Winterferien" [[1 2 6 2]]
     "Osterferien" [[22 3 3 4]]
     "Schulfrei" [[7 5]]
     "Sommerferien" [[10 7 20 8]]
     "Herbstferien" [[9 10 23 10]]
     "Weihnachtsferien" [[23 12 31 12]]}}

   2028
   {"Baden-Württemberg"
    {"Sommerferien" [[27 7 9 9]]}
    "Bayern"
    {"Frühjahrsferien" [[28 2 3 3]]
     "Osterferien" [[10 4 21 4]]
     "Pfingstferien" [[6 6 16 6]]
     "Sommerferien" [[31 7 11 9]]
     "Weihnachtsferien" [[23 12 5 1]]}
    "Berlin"
    {"Winterferien" [[31 1 5 2]]
     "Pfingstferien" [[1 6 2 6]]
     "Sommerferien" [[1 7 12 8]]
     "Herbstferien" [[2 10 14 10]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Brandenburg"
    {"Winterferien" [[31 1 5 2]]
     "Sommerferien" [[29 6 12 8]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Bremen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[10 4 22 4]]
     "Sommerferien" [[20 7 30 8]]
     "Weihnachtsferien" [[27 12 6 1]]}
    "Hamburg"
    {"Sommerferien" [[1 7 11 8]]}
    "Hessen"
    {"Sommerferien" [[3 7 11 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[5 2 17 2]]
     "Pfingstferien" [[2 6 6 6]]
     "Sommerferien" [[26 6 5 8]]
     "Weihnachtsferien" [[21 12 3 1]]}
    "Niedersachsen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[10 4 22 4]]
     "Sommerferien" [[20 7 30 8]]
     "Weihnachtsferien" [[27 12 6 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[10 4 22 4]]
     "Sommerferien" [[10 7 22 8]]
     "Herbstferien" [[23 10 4 11]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[10 4 21 4]]
     "Sommerferien" [[3 7 11 8]]
     "Herbstferien" [[9 10 20 10]]
     "Weihnachtsferien" [[21 12 8 1]]}
    "Saarland"
    {"Winterferien" [[21 2 29 2]]
     "Osterferien" [[12 4 21 4]]
     "Sommerferien" [[3 7 11 8]]
     "Herbstferien" [[9 10 20 10]]
     "Weihnachtsferien" [[20 12 2 1]]}
    "Sachsen"
    {"Winterferien" [[14 2 26 2]]
     "Sommerferien" [[22 7 1 9]]
     "Herbstferien" [[23 10 3 11]]
     "Weihnachtsferien" [[23 12 3 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[7 2 12 2]]
     "Osterferien" [[10 4 22 4]]
     "Pfingstferien" [[3 6 10 6]]
     "Sommerferien" [[22 7 1 9]]
     "Weihnachtsferien" [[22 12 2 1]]}
    "Schleswig-Holstein"
    {"Schulfrei" [[31 1] [26 5]]
     "Osterferien" [[3 4 15 4]]
     "Sommerferien" [[24 6 4 8]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Thüringen"
    {"Winterferien" [[7 2 12 2]]
     "Osterferien" [[3 4 15 4]]
     "Schulfrei" [[26 5]]
     "Sommerferien" [[22 7 1 9]]
     "Herbstferien" [[23 10 3 11]]
     "Weihnachtsferien" [[23 12 5 1]]}}

   2029
   {"Baden-Württemberg"
    {"Sommerferien" [[26 7 8 9]]}
    "Bayern"
    {"Frühjahrsferien" [[12 2 16 2]]
     "Osterferien" [[26 3 6 4]]
     "Pfingstferien" [[22 5 1 6]]
     "Sommerferien" [[30 7 10 9]]
     "Weihnachtsferien" [[24 12 4 1]]}
    "Berlin"
    {"Winterferien" [[29 1 3 2]]
     "Sommerferien" [[1 7 11 8]]
     "Herbstferien" [[1 10 12 10]]
     "Weihnachtsferien" [[21 12 4 1]]}
    "Brandenburg"
    {"Winterferien" [[29 1 3 2]]
     "Sommerferien" [[28 6 11 8]]
     "Herbstferien" [[1 10 12 10]]
     "Weihnachtsferien" [[21 12 4 1]]}
    "Bremen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[19 3 3 4]]
     "Sommerferien" [[19 7 29 8]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Hamburg"
    {"Sommerferien" [[1 7 10 8]]}
    "Hessen"
    {"Sommerferien" [[16 7 24 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[5 2 16 2]]
     "Osterferien" [[26 3 4 4]]
     "Sommerferien" [[18 6 28 7]]
     "Weihnachtsferien" [[21 12 4 1]]}
    "Niedersachsen"
    {"Winterferien" [[1 2 2 2]]
     "Osterferien" [[19 3 3 4]]
     "Sommerferien" [[19 7 29 8]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[26 3 7 4]]
     "Schulfrei" [[22 5]]
     "Sommerferien" [[2 7 14 8]]
     "Herbstferien" [[15 10 27 10]]
     "Weihnachtsferien" [[20 12 4 1]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[26 3 6 4]]
     "Sommerferien" [[16 7 24 8]]
     "Herbstferien" [[22 10 2 11]]
     "Weihnachtsferien" [[24 12 9 1]]}
    "Saarland"
    {"Winterferien" [[12 2 16 2]]
     "Osterferien" [[26 3 6 4]]
     "Pfingstferien" [[22 5 25 5]]
     "Sommerferien" [[16 7 24 8]]
     "Herbstferien" [[22 10 2 11]]
     "Weihnachtsferien" [[21 12 4 1]]}
    "Sachsen"
    {"Winterferien" [[5 2 16 2]]
     "Osterferien" [[29 3 6 4]]
     "Sommerferien" [[21 7 31 8]]
     "Herbstferien" [[22 10 2 11]]
     "Weihnachtsferien" [[22 12 4 1]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[5 2 10 2]]
     "Osterferien" [[26 3 31 3]]
     "Sommerferien" [[21 7 31 8]]
     "Herbstferien" [[29 10 2 11]]
     "Weihnachtsferien" [[21 12 5 1]]}
    "Schleswig-Holstein"
    {"Schulfrei" [[29 1] [11 5]]
     "Sommerferien" [[23 6 3 8]]
     "Weihnachtsferien" [[21 12 8 1]]}
    "Thüringen"
    {"Winterferien" [[12 2 17 2]]
     "Osterferien" [[26 3 7 4]]
     "Schulfrei" [[11 5]]
     "Sommerferien" [[21 7 31 8]]
     "Herbstferien" [[22 10 3 11]]
     "Weihnachtsferien" [[22 12 4 1]]}}

   2030
   {"Baden-Württemberg"
    {"Sommerferien" [[25 7 7 9]]}
    "Bayern"
    {"Frühjahrsferien" [[4 3 8 3]]
     "Osterferien" [[15 4 26 4]]
     "Pfingstferien" [[11 6 21 6]]
     "Sommerferien" [[29 7 9 9]]
     "Schulfrei" [[20 11]]}
    "Berlin"
    {"Winterferien" [[4 2 9 2]]
     "Schulfrei" [[7 6]]
     "Sommerferien" [[4 7 17 8]]}
    "Brandenburg"
    {"Winterferien" [[4 2 9 2]]
     "Sommerferien" [[4 7 17 8]]}
    "Bremen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[8 4 23 4]]
     "Sommerferien" [[11 7 21 8]]}
    "Hamburg"
    {"Sommerferien" [[4 7 14 8]]}
    "Hessen"
    {"Sommerferien" [[22 7 30 8]]}
    "Mecklenburg-Vorpommern"
    {"Winterferien" [[4 2 15 2]]
     "Pfingstferien" [[7 6 11 6]]
     "Sommerferien" [[1 7 10 8]]}
    "Niedersachsen"
    {"Winterferien" [[31 1 1 2]]
     "Osterferien" [[8 4 23 4]]
     "Sommerferien" [[11 7 21 8]]}
    "Nordrhein-Westfalen"
    {"Osterferien" [[15 4 27 4]]
     "Sommerferien" [[24 6 6 8]]}
    "Rheinland-Pfalz"
    {"Osterferien" [[15 4 30 4]]
     "Sommerferien" [[22 7 30 8]]}
    "Saarland"
    {"Winterferien" [[25 2 5 3]]
     "Osterferien" [[15 4 26 4]]
     "Sommerferien" [[22 7 30 8]]}
    "Sachsen"
    {"Winterferien" [[18 2 1 3]]
     "Osterferien" [[19 4 26 4]]
     "Sommerferien" [[13 7 23 8]]}
    "Sachsen-Anhalt"
    {"Winterferien" [[4 2 8 2]]
     "Osterferien" [[8 4 20 4]]
     "Sommerferien" [[13 7 23 8]]}
    "Schleswig-Holstein"
    {"Winterferien" [[28 1 29 1]]
     "Osterferien" [[8 4 20 4]]
     "Schulfrei" [[31 5]]
     "Sommerferien" [[8 7 17 8]]
     "Weihnachtsferien" [[20 12 6 1]]}
    "Thüringen"
    {"Winterferien" [[11 2 16 2]]
     "Osterferien" [[8 4 20 4]]
     "Schulfrei" [[31 5]]
     "Sommerferien" [[13 7 23 8]]}}})
